module.exports = __webpack_public_path__ + "static/media/1001690.fa6845fc.jpg";